import { useState, useEffect } from 'react'
import { Axios } from 'component/base'

export const useShokuin = (_key, refresh) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({})

  const ajax = async key => {
    setLoading(true)
    const { data, error } = await Axios.ajax.get(
      `/api/staff/master/shokuin_zokusei/${key}`,
      {}
    )
    if (error) {
      setLoading(false)
      return
    }
    setData(data || {})
    setLoading(false)
  }

  useEffect(() => {
    _key && ajax(_key)
  }, [_key, refresh])

  return {
    data,
    loading,
  }
}
